export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || '';
export const MULTIVERSE_URL = process.env.REACT_APP_MULTIVERSE_URL || '';
export const CHAT_URL = process.env.REACT_APP_CHAT_URL || '';
export const DASHBOARD_BASE_URL = process.env.REACT_APP_DASHBOARD_URL || '';
export const DASHBOARD_APP_BASE_URL = process.env.REACT_APP_DASHBOARD_APP_BASE_URL || '';
export const OCTOPUS_APP_BASE_URL = process.env.REACT_APP_OCTOPUS_APP_BASE_URL || '';
